type MergeRecord = <T, R extends Partial<T>>(
  record: Record<string, T>,
  id: string,
  newValues: R
) => Record<string, T | (T & R)>;
export const mergeRecord: MergeRecord = (record, id, newValues) => {
  const oldValues = record[id];
  const entry = {
    ...oldValues,
    ...newValues,
  };

  return {
    ...record,
    [id]: entry,
  };
};
